import useReveal from './useReveal';

const projects = [
  {
    tag: 'Mechanical & Civil Engineering',
    title: 'Glencore GGV / TSO / Impunzi',
    desc: 'Steel structure maintenance and upgrades, extension and installation of underground conveyors, fabrication and supply of structural steelwork, civil works including concrete slabs, splints, and casting.',
    year: '2020 – 2024',
    bg: 'linear-gradient(135deg, #0A2540 0%, #1CA3DE 100%)',
  },
  {
    tag: 'Steel Fabrication',
    title: 'Structural Steel Supply',
    desc: 'Custom fabrication and supply of heavy structural steelwork for mining plant facilities.',
    bg: 'linear-gradient(135deg, #1CA3DE, #0A2540)',
  },
  {
    tag: 'Civil Works',
    title: 'Concrete Slabs & Road Works',
    desc: 'Construction of concrete platforms, bridge works, and general road rehabilitation.',
    bg: 'linear-gradient(135deg, #0A2540, #1CA3DE)',
  },
  {
    tag: 'Plant & Maintenance',
    title: 'Underground Conveyor Extension',
    desc: 'Installation and extension of underground conveyor systems at active mining operations.',
    bg: 'linear-gradient(135deg, #0A2540, #5BB8E8)',
  },
  {
    tag: 'Mining Services',
    title: 'Facility Renovations',
    desc: 'Renovation of change houses, ablution facilities, and security fencing for mining operations.',
    bg: 'linear-gradient(135deg, #071a35, #1CA3DE)',
  },
];

export default function Projects() {
  const hdrRef = useReveal();
  const gridRef = useReveal();

  return (
    <section id="projects">
      <div className="proj-hdr reveal" ref={hdrRef}>
        <div>
          <div className="eyebrow">Our Portfolio</div>
          <h2 className="sec-title">Completed<br />Projects</h2>
        </div>
        <a href="#contact" className="proj-link">Start a Project →</a>
      </div>

      <div className="proj-grid reveal" ref={gridRef}>
        {projects.map((p, i) => (
          <div className="proj-card" key={i}>
            <div className="proj-bg" style={{ background: p.bg }} />
            <div className="proj-over">
              <div className="proj-tag">{p.tag}</div>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </div>
            {p.year && <div className="proj-yr">{p.year}</div>}
          </div>
        ))}
      </div>
    </section>
  );
}
